export interface AreaPersonale {
  id: string;
  lastModified: string;
  posizioniDebitorie: PosizioneDebitoria[];
  dataAggiornamento: Date;
  profiloUtente: ProfiloUtente;
  uid: string;
  pagamenti: Pagamento[];
}

export interface Carrello {
  posizioniDebitorie: PosizioneDebitoria[];
  tipologiaCarrello: number;
  idTransazione: string | null;
  dataTransazione: string | null;
  //urlCallback: string | null;
  codiceIpaEnte: string;
  modelloPagamento: number;
  //uidAreaDiPagamento: string;
  areaDiPagamento: string | null;
  urlReturnPaymentTORedirect: string | null;
  urlCallToClientWeb: string | null;
}

export interface PosizioneDebitoria {
  dataDiScadenza: string | null;
  codiceEntePlugAndPay: string | null;
  codiceIpa: string | null;
  intestazioneEntePlugAndPay: string | null;
  codiceServizio: string;
  descrizioneServizio: string | null;
  causale: string;
  codiceRiferimentoCreditore: string | null;
  tipoRiferimentoCreditore: string | null;
  iuv?: string | null;
  numeroAvviso?: string;
  importo: number;
  spontaneo: boolean;
  isPagato: boolean;
  hasReceipt: boolean;
  datiPagamento?: DatiPagamento[] | null;
  idsTariffa?: string[];
  quantita?: number;
  datiContribuente: DatiContribuente | null;
  datiCreditore?: DatiCreditore | null;
  id?: string | undefined;
  idApplicazioneEntePosizione?: string | undefined;
  dataPagamento: string | null;
  isMultibeneficiario?: boolean;
}
export interface Pagamento {
  carrelloPagato: CarrelloPagato
  dataPagamento: Date
}
export interface CarrelloPagato {
  posizioniDebitoriePagata: PosizioneDebitoriaPagata[];
}
export interface PosizioneDebitoriaPagata {
  importo: number;
  numeroAvviso: string;
  causale: string | null | undefined;
  codiceServizio: string;
  descrizioneServizio: string;
  intestazioneEnte: string;
  // aggiungere i campi a PosizioneDebitoria_PagamentiRecenti_Pagata
  codiceFiscalePartitaIvaCittadino: string | null | undefined;
  codiceEnteCreditore: string | null;
  idApplicazioneEntePosizione?: string | undefined;
  isPagato: boolean;
  hasReceipt: boolean;
}
// TASK 239: merge con "debtPositionsPagamentiRecenti" & "debtPositionsPagate"
export interface PosizioneDebitoria_PagamentiRecenti_Pagata {
  importo: number;
  dataPagamento: string | null;
  numeroAvviso: string;
  causale: string | null | undefined;
  codiceServizio: string;
  descrizioneServizio: string | null;
  intestazioneEnte: string;
  // Nuovi campi per la STAMPA RICEVUTA
  codiceFiscalePartitaIvaCittadino: string | null | undefined;
  codiceEnteCreditore: string | null;
  idApplicazioneEntePosizione?: string | undefined;
  tipo: string;
}
export interface  PosizioneDebitoriaStampaAvviso {
  codiceEnte: string | null | undefined;
  identificativoPosizione: string | null | undefined;
  codiceFiscalePartitaIva: string | null | undefined;
  codiceIpaEnte: string | null | undefined;
  idApplicazioneEntePosizione: string | null | undefined;
}

export interface AreaDiPagamentoViewModel {
  id: string;
  lastModified: string;
  carrelloEnteDiContesto: Carrello;
  uidCarrelloEnteDiContesto: string;
  carrelloMyPay: Carrello;
  uidCarrelloMyPay: string;
  carrelloMultiBeneficiario: Carrello;
  uidCarrelloMultiBeneficiario: string;
  profile: ProfiloUtente;
}
export interface AreaDiPagamentoAnonimaViewModel {
  profile?:any
  carrelloEnteDiContesto: Carrello | null;
  carrelloMyPay: Carrello | null ;
  carrelloMultiBeneficiario: Carrello | null;
}

export interface DatiPagamento {
  chiave: string;
  descrizione?: string;
  valore: string;
}

export interface DatiContribuente {
  civico: string;
  codiceAvviamentoPostale: string;
  codiceFiscalePartitaIva: string;
  email: string;
  indirizzo: string;
  localita: string;
  telefono: string;
  nominativo: string;
  provincia: string;
  nomeNazione: string;
  tipologiaPagatore: number;
}

export interface DatiCreditore {
  codiceEnte: string;
  codiceFiscalePartitaIva: string;
  iban: string;
  intestazione: string;
}

export interface ProfiloUtente extends ProfiloUtenteAnonimo {
  id: string;
  lastModified: string;
  userObjectId: string;
  codiceFiscale: string;
}

export interface ProfiloUtenteAnonimo {
  codiceIpaEnte: string;
}

export const IsProfiloUtente = (obj: ProfiloUtente | ProfiloUtenteAnonimo): obj is ProfiloUtente => {
  return Object.prototype.hasOwnProperty.call(obj, "id");
}

export enum TipologiaCarrello {
  EnteDiContesto = 0,
  MyPay = 1,
  MultiBeneficiario = 2,
}
export enum UserType {
  Authenticated = 'Authenticated',
  Anonymous = 'Anonymous',
}

export interface PagamentoAreaPersonaleRequest {
  codiceIpa: string
  modelloPagamento : number
  urlCallback : string
  tipologiaCarrello: number
}

export interface PagamentoAnonimoRequest {
  codiceIpa: string
  modelloPagamento : number
  areaDiPagamentoAnonimaViewModel : AreaDiPagamentoAnonimaViewModel
  urlCallback : string
}

export interface PagamentoAreaPersonaleResponse {
  esitiInvioCarrelloPosizioni: EsitoInvioCarrelloPosizioniViewModel[] | undefined;
  idTransazione: string | undefined;
  urlRedirect: string | undefined;
}

export interface EsitoInvioCarrelloPosizioniViewModel {
  codiceRiferimentoCreditore: string | undefined;
  erroriDiValidazione: ErroreDiValidazionePosizioneViewModel[] | undefined;
  esito: number | undefined; // ok: 0
  identificativoPosizione: string | undefined;
  tipoRiferimentoCreditore: string | undefined;
}

export interface ErroreDiValidazionePosizioneViewModel {
  codice: string | undefined;
  descrizione: string | undefined;
}

export type ModelloPagamento = 0 | 1 | 3;

export interface PagamentoDirettoRequest {
  posizioneDebitoria: PosizioneDebitoria,
  urlCallback: string,
  modelloPagamento: ModelloPagamento,
  // [x] - WorkItem 11520: Aggiungere nuovo campo "isCfAnonimo" per distinguere i pagamenti anonimi (codice fiscale utente = 'ANONIMO') dagli altri pagamenti
  isCfAnonimo?: boolean,
  tipologiaCarrello: number,
  idDominioBeneficiario?: string
}
// PAGA UN AVVISO GENERICO
export interface PagamentoAnonimoGenericoRequest {
  posizioneDebitoria: PosizioneDebitoria,
  urlCallback: string,
  idDominioBeneficiario?: string,
}

export interface PagamentoDirettoResponse {
  urlRedirect: string,
  idTransazione: string,
  inviatoConSuccesso: boolean,
  motivoFallimento: string
}

export interface MyPayRequest {
  codiceEnte: string,
  codiceServizio: string
}
